import React from 'react';
import mailIcon from '../assets/figma/mail.svg';
import linkedinIcon from '../assets/figma/github.svg';
import githubIcon from '../assets/figma/file-text.svg';
import codeSquareIcon from '../assets/figma/linkedin.svg';
import fileTextIcon from '../assets/figma/code-square.svg';
import resumePdf from '../assets/resume_kaustubh.pdf';

const links = [
  { label: 'kaustubh.bhosale30@gmail.com', icon: mailIcon, href: 'mailto:kaustubh.bhosale30@gmail.com' },
  { label: 'LinkedIn', icon: linkedinIcon, href: 'https://www.linkedin.com/in/kaustubh-bhosale-331956256/' },
  { label: 'GitHub', icon: githubIcon, href: 'https://github.com/Sipher2003' },
  { label: 'LeetCode', icon: codeSquareIcon, href: 'https://leetcode.com/u/Sipher2003' },
  { label: 'Resume', icon: fileTextIcon, href: resumePdf, target: '_blank' },
];

const Main = () => (
  <main className="hero-section">
    <div className="hero-content">
      <header className="hero-header-block">
        <div className="hero-kicker">
          <span className="hero-kicker-dot" />
          <span>Available for Engineering Roles</span>
        </div>
        <h1>Kaustubh Bhosale</h1>
        <p className="hero-role">Software Engineer · Data Enthusiast · Builder</p>
        <p className="hero-description">
          MCA student at VES Institute of Technology, Mumbai. I build data pipelines,
          AI-powered apps, and full-stack systems.
        </p>
      </header>

      <section className="hero-actions" aria-label="Connect with me">
        <p className="hero-actions-label">Connect with me</p>
        <div className="hero-links">
          {links.map(({ label, icon, href, target }) => (
            <a className="hero-link" href={href} key={label} target={target || (href.startsWith('http') ? '_blank' : undefined)} rel={target === '_blank' ? 'noreferrer' : undefined}>
              <img src={icon} alt="" aria-hidden="true" />
              <span>{label}</span>
            </a>
          ))}
        </div>
      </section>
    </div>
  </main>
);

export default Main;
